export default class BillerService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getCachedListsStats() {
		return this.apiService.callGet('optimization/cached_lists_stats')
	}

	clearCache(params) {
		return this.apiService.callPost('optimization/clear_cache', params)
	}

	refreshCachedLists(params) {
		return this.apiService.callPost('optimization/refresh_cached_lists', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/OptimizationService.js